import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/router/routes'
import registerRouterGuard from '@/router/guard'
import { notFound, svgView } from '@/router/base'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'layoutMain',
      component: () => import('@/layout/main.vue'),
      children: routes,
    },
    notFound,
    svgView,
  ],
})

// 路由守卫
registerRouterGuard(router)

export default router
